<template>
    <div class="col-md-12 col-sm-12">
<!--        <div class="row"
             v-if="this.$store.getters.getAcls.includes('mkt_it') && !this.$store.getters.getUser.dealer.has_demo">
            <div class="col-md-12 col-sm-12">
                <b-alert variant="info" show>
                    <div>
                        {{
                            $t('To create demo in XStore, you can activate your demo account (ex-novo or converting an existing account).')
                        }}
                        <router-link
                            :to="{ name: 'AddDemoCustomer'}" class="text-primary cursor-pointer">{{ $t('Click here') }}
                        </router-link>
                        {{ $t('to activate it.') }}
                    </div>
                </b-alert>
            </div>
        </div>-->
        <div class="card-widget">
            <div class="card-widget-title">
                <div class="card-widget-title-label w-100 d-flex justify-content-between align-items-center">
                    <h3>{{ $t('Customers') }}</h3>
                    <div class="float-lg-right mt-3 mt-lg-0">
                        <b-button-group>
                            <b-dropdown variant="outline-secondary" right :text="$t('Manage')" v-if="false">
                                <b-dropdown-item @click="$bvModal.show('export-customers-modal')">{{$t('Export')}}</b-dropdown-item>
                            </b-dropdown>

                            <router-link :to="{ name: 'Create Customer' }" class="btn btn-primary">{{ $t('Create') }}</router-link>
                        </b-button-group>
                    </div>
                </div>
            </div>
            <div class="card-widget-content">
                <!-- start:: search & filters -->
                <div class="search-tool">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="input-group flex-nowrap">
                                <b-form-input
                                    type="text"
                                    id="name"
                                    name="name"
                                    :placeholder="$t('Name')"
                                    v-model='searchParams.name'
                                />
                                <div class="input-group-append">
                                  <span class="input-group-text" id="addon-wrapping"
                                  ><i class="fas fa-search"></i
                                  ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <button
                                type="button"
                                id="buttonAdvancedFilters"
                                class="btn btn-outline-primary"
                                data-toggle="collapse"
                                href="#advancedFilters"
                                role="button"
                                aria-expanded="false"
                                aria-controls="collapseExample"
                            >
                                <i class="fas fa-filter"></i>
                                <span>{{ $t("Advanced Search") }}</span>
                            </button>
                            <button
                                type="button"
                                id="buttonAdvancedFiltersReset"
                                class="btn btn-outline-secondary"
                                href="#"
                                role="button"
                                @click="resetSearch"
                            >
                                <i class="fas fa-redo"></i> <span>{{ $t("Reset") }}</span>
                            </button>

                            <div class="float-lg-right mt-3 mt-lg-0">
                                <button
                                    type="button"
                                    id="buttonModifyTableHeader"
                                    class="btn"
                                    href="#"
                                    @click="$bvModal.show('modifyBTableHeader')">
                                    <i class="fas fa-sliders-h"></i>
                                </button>
                            </div>

                        </div>
                        <div class="col-md-12">
                            <div class="collapse" id="advancedFilters">
                                <div class="card card-body advanced-filters">
                                    <form>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <b-form-group
                                                    :label="$t('VAT Number')"
                                                    label-for="vatNumber"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        id="vatNumber"
                                                        name="vatNumber"
                                                        :placeholder="$t('VAT Number')"
                                                        v-model='searchParams.vat_number'
                                                    />
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group
                                                    :label="$t('Email')"
                                                    label-for="email"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        id="email"
                                                        name="email"
                                                        placeholder=""
                                                        v-model='searchParams.email'
                                                    />
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end:: search & filters -->
                <b-table
                    striped
                    hover
                    responsive
                    ref="table"
                    :current-page="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :show-empty="true"
                    :empty-text="$t('There are no records to show')"
                    :empty-filtered-text="$t('There are no records matching your request')"
                    :filter="filterSearch"
                    :filter-debounce="500"
                    :fields="fields"
                    :items="customerProvider"

                    :sort-by.sync="sortParams.field"
                    :sort-desc.sync="sortParams.order"
                    @sort-changed="sortChangeCallback"

                    class="table table-responsive-sm"
                    sort-icon-left
                    v-if="!loadingUiConfiguration">

                    <template v-slot:head()="data">
                        <span class="">{{ data.label }}</span>
                    </template>
                    <template v-slot:cell(name)="data">
                        <div>
                            <div>
                                <router-link :to="{ name: 'Customer', params: { customer_id: data.item.id }}">
                                    {{ data.item.name }}
                                </router-link>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell(created_at)="data">{{ formatDate(data.item.created_at)  }}</template>
                    <template v-slot:cell(actions)="data">
                        <div class="action-button">
                            <router-link :id="'cashflow_show_'+data.item.id" class="btn btn-outline-primary"
                                         data-toggle="tooltip" data-placement="top" title=""
                                         data-original-title="Mostra dettagli"
                                         :to="{name: 'Customer', params: {customer_id: data.item.id}}">
                                <i class="fas fa-eye"></i>
                            </router-link>
                        </div>
                    </template>
                    <template v-slot:table-busy>
                        <div class="text-center text-muted my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>{{ $t('Loading...') }}</strong>
                        </div>
                    </template>
                </b-table>
                <template v-else>
                    <div class="text-center text-muted my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ $t('Loading...') }}</strong>
                    </div>
                </template>

                <table-pagination :pagination="pagination" :isBusy="isBusy"
                                  :totalLabel="$t('Total items')"></table-pagination>

            </div>
        </div>
        <b-modal
          id="export-customers-modal"
          :title="$t('Customers export')"
          :ok-title="$t('Confirm')"
          :cancel-title="$t('Dismiss')"
          ok-variant="primary"
          cancel-variant="outline-secondary"
          @ok="exportCustomers" effect="fade/zoom">
          <p>{{$t('You have requested an export of the customers based on the filters applied, once the export is complete we will send you the file via email to the address indicated below')}}</p>
          <b-form-input v-model="exportNotificationEmail"></b-form-input>
        </b-modal>
        <BTableHeaderConfiguration
            :fieldsSettings="fieldsSettings"
            :preference-type="uiPreferenceKey"
            @changed="updateUiPreferences"/>
    </div>

</template>

<script>
import moment from 'moment';
import apiHelpers from "../../js/services/apiHelpers";
import tableQuerySync from "../../js/services/tableQuerySync";
import {TablePagination} from "../../components";
import {has} from 'lodash';
import BTableHeaderConfiguration from "../components/BTableHeaderConfiguration.vue";
import axios from "axios";
import {mapState} from 'vuex';


export default {
    name: 'customers',
    mixins: [apiHelpers, tableQuerySync],

    components: {BTableHeaderConfiguration, TablePagination},
    data() {
        return {
            clienti: [],
            updatedHeaderList: [],
            loading: true,
            loadingUiConfiguration: true,
            currentCustomer: null,
            //dangerModal: false,
            pagination: {
                perPage: 10,
            },
            searchParams: {
                name: '',
                vat_number: '',
                email: '',
            },
            sortParams: {
              field: 'name',
              order: false,
            },
            exportNotificationEmail: '',
            search: null,
            uiPreferenceKey: "xdealer:customers:index",
            fields: [],
            fieldsSettings: [
                {
                    key: "name",
                    label: this.$t("Name"),
                    sortable: true,
                    stickyColumn: true,
                    thStyle: {minWidth: '250px'},
                },
                {
                    key: "vat_number",
                    label: this.$t("VAT Number"),
                    sortable: true,
                    editable: true,
                    visible: true,
                    thStyle: {minWidth: '120px'},
                },
                {
                    key: "fiscal_code",
                    label: this.$t("Fiscal Code"),
                    sortable: true,
                    editable: true,
                    visible: false,
                    thStyle: {minWidth: '160px'},
                },
                {
                    key: "street",
                    label: this.$t("Street"),
                    sortable: true,
                    editable: true,
                    visible: false,
                    thStyle: {minWidth: '160px'},
                },
                {
                    key: "city",
                    label: this.$t("City"),
                    sortable: true,
                    editable: true,
                    visible: false,
                    thStyle: {minWidth: '140px'},
                },
                {
                    key: "province",
                    label: this.$t("Province"),
                    sortable: true,
                    editable: true,
                    visible: false
                },
                {
                    key: "postal_code",
                    label: this.$t("Postal Code"),
                    sortable: true,
                    editable: true,
                    visible: false,
                    thStyle: {minWidth: '140px'},
                },
                {
                    key: "email",
                    label: this.$t("Email"),
                    sortable: true,
                    editable: true,
                    visible: true
                },
                {
                    key: "pec",
                    label: this.$t("PEC"),
                    sortable: true,
                    editable: true,
                    visible: false
                },
                {
                    key: "phone",
                    label: this.$t("Phone"),
                    sortable: true,
                    editable: true,
                    visible: true
                },
                {
                    key: "created_at",
                    label: this.$t("Active from"),
                    sortable: true,
                    thStyle: {minWidth: '120px'},
                    editable: true,
                    visible: false
                },
                {
                    key: 'actions',
                    label: '',
                    sortable: false,
                }
            ],
        }
    },
    mounted() {
        this.exportNotificationEmail = this.dealerEmail;
        this.setSearchFilter();
        this.fields = this.fieldsSettings;
    },
    methods: {
      sortChangeCallback (ctx) {
        this.sortParams.field = ctx.sortBy;
        this.sortParams.order = ctx.sortDesc;
      },
    customerProvider (ctx) {
      if (!ctx.sortBy) {
        ctx.sortBy = 'name';
        ctx.sortDesc = false;
      }

      let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/customers?` + this.ctxQueryStringV2(ctx);
      return axios.get(url)
        .then(({data}) => {
          this.updatePaginationMeta(data);
          return data.data;
        }).catch(e => {
          console.log(e);
        });
    },

    setSearchFilter() {
      Object.keys(this.$route.query).forEach(key => {
        if (has(this.searchParams, key)) {
          this.searchParams[key] = this.$route.query[key];
        }
      })
    },

    resetSearch() {
      this.searchParams.name = '';
      this.searchParams.vat_number = '';
      this.searchParams.email = '';

      this.search = null;
      this.pagination.currentPage = 1;
    },
    exportCustomers($event) {
      axios.post('/dealer/api/v2/exports/customers', {
        notify_on_complete_email: this.exportNotificationEmail,
        filters: {
          name: this.searchParams.name,
          vat_number: this.searchParams.vat_number,
          email: this.searchParams.email,
          sort: this.sortParams,
        }
      }).then(() => {
        this.$notify({
          group: "form",
          type: "success",
          title: this.$t("Success"),
          text: this.$t("Requeste sended.")
        });
      })
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD hh:mm:ss').format('DD-MM-YYYY')
    },

    updateUiPreferences(newFields) {
      this.fields = newFields;
      this.loadingUiConfiguration = false;
    },
  },
    computed: {
        filterSearch() {
            const params = {};

            if (this.searchParams.name != "") {
                params.name = this.searchParams.name;
            }

            if (this.searchParams.vat_number != "") {
                params.vat_number = this.searchParams.vat_number;
            }

            if (this.searchParams.email != "") {
                params.email = this.searchParams.email;
            }

            this.search = params
            return params;
        },
      ...mapState({
        dealerEmail: (state) => {
          return state.account.user.email
        },
      }),
    }
}
</script>

<style>
.smCol {
    min-width: 100px;
}

.mdCol {
    min-width: 150px;
}

.lgCol {
    min-width: 200px;
}

.tableHeader {
    text-align: left;
    align-content: left;
}
</style>
